<div id="utilization-weekly-calculation-chart-container">
  <chart id="utilization-weekly-calculation-chart"
    *ngIf="utilizationLineChartData"
    [dataSet]="utilizationLineChartData"
    [title]="'Utilization'"
    [options]="utilizationLineChartOptions"
    [chartType]="'line'">
  </chart>
</div>
